import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FadeLoader } from 'react-spinners';
import QuantityDropdown from './QuantityDropdown';
import ServicecodeContent from './ServicecodeContent';
import Icon from '../../icons';
import { CHECK } from '../../constants/iconNames';
class Service extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            amount: this.props.service.quantity,
            showDropdown: false,
            value: '',
        };
        this.setDropDownValues = max => {
            const values = [];
            for (let i = 1; i <= max; i++) {
                const selected = i === this.state.amount;
                values.push({
                    name: (_jsxs("span", { className: selected ? 'selected' : '', children: [i, selected && _jsx(Icon, { name: CHECK })] }, i)),
                    value: i,
                });
            }
            return values;
        };
        this.toggleDropdown = () => {
            this.setState({ showDropdown: !this.state.showDropdown });
        };
        this.selected = event => {
            const { requestUpdateService, service: { workOrderServiceId, id }, workOrderId, } = this.props;
            this.setState({
                showDropdown: false,
                amount: event.value,
            });
            requestUpdateService(workOrderId, workOrderServiceId, id, this.state.amount, false);
        };
        this.removeClick = () => {
            const { requestRemoveService, service: { workOrderServiceId }, workOrderId, } = this.props;
            requestRemoveService(workOrderId, workOrderServiceId);
        };
    }
    render() {
        const { max, workOrderServiceIdToBeChanged, service, technician } = this.props;
        const { amount, showDropdown, value } = this.state;
        return (_jsxs("div", { className: "service", children: [service.workOrderServiceId === workOrderServiceIdToBeChanged && (_jsx("div", { className: "service__spinner", children: _jsx(FadeLoader, {}) })), max > 1 && (_jsx(QuantityDropdown, { dropDownValues: this.setDropDownValues(max), showDropdown: showDropdown, toggleDropdown: this.toggleDropdown, selected: this.selected, value: value, amount: amount })), _jsx(ServicecodeContent, { service: service, amount: amount, noDropdown: max === 1, removeClick: this.removeClick, workOrderServiceIdToBeChanged: workOrderServiceIdToBeChanged, technician: technician })] }));
    }
}
Service.propTypes = {
    max: PropTypes.number.isRequired,
    workOrderServiceIdToBeChanged: PropTypes.number,
    requestRemoveService: PropTypes.func.isRequired,
    requestUpdateService: PropTypes.func.isRequired,
    service: PropTypes.objectOf(PropTypes.any).isRequired,
    technician: PropTypes.bool.isRequired,
    workOrderId: PropTypes.number.isRequired,
};
Service.defaultProps = {
    workOrderServiceIdToBeChanged: null,
};
export default Service;
